// MUI
import { Grid } from "@mui/material";
import AssigneesDetailsCard from "./AssigneesDetailsCard";

import { IEmployeeDetails } from "@PayPlans/types/historical";

type AssigneesListProps = {
	assigneesDetailsList: IEmployeeDetails[];
};
export default function AssigneesList(props: AssigneesListProps) {
	const { assigneesDetailsList = [] } = props;

	return (
		<Grid style={{ maxHeight: 200, overflow: "auto" }} container spacing={2} mt={"13px"}>
			{assigneesDetailsList.map((assignee) => (
				<Grid item xs={6} key={assignee._id}>
					<AssigneesDetailsCard assigneeDetails={assignee} />
				</Grid>
			))}
		</Grid>
	);
}
